import React from "react";
import { HeroReuse } from "../../components/common/HeroReuse";
import articleImg from "../../assets/flow3.svg"
import ArticleContent from "../../components/sections/blog/ArticleContent";
import RequestDemo from "../../components/common/RequestDemo";
import { articleContent2 } from "../../constants/data";

const ArticleSecond = ({title, description }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-8 sm:gap-16 lg:gap-0">
      <HeroReuse
        Title="Understanding Compliance and Regulatory Compliance: A Beginner’s Guide"
        Description="The purpose of this article is to explain the basics of compliance and regulatory compliance in general. Recently, many people new to the market have been asking me, “What is compliance?”"
        date="12 Mar 2025"
        imgUrl={articleImg}
        titleClass={'tracking-tight'}
      />
      <ArticleContent content={articleContent2} toolsClass="font-bold text-darkGray"/>
      <RequestDemo/>
    </div>
  );
};

export default ArticleSecond;
